import { render } from "./confirm.vue?vue&type=template&id=dcb5cc4c&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=dcb5cc4c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb5cc4c"]])

export default __exports__